module.exports = __webpack_public_path__ + "img/user-empty.52ec6ab7.svg";